import { ReviewModel, IReview } from "./review.model";

export class ReviewDemandModel extends ReviewModel {
  hasRecruited() {
    return this[IReview.recruited] === true;
  }
}
